// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/routes/login.tsx"
);
import.meta.hot.lastModified = "1747581129013.0396";
}
// REMIX HMR END

// This file is an alias for the set-username route for better semantics
export { action, default, loader } from './set-username'
